import React from 'react';
import { IconProps } from '.';

const SvgQuestionMark = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M13 20h-2v-2.5h2V20ZM12.019 4c2.413 0 4.67 2.173 4.51 4.81-.062 1.03-.475 1.846-.964 2.516-.46.63-1.067 1.225-1.486 1.683l-.014.014-.014.013v.001l-.003.004a5.374 5.374 0 0 0-.534.678c-.298.45-.495.913-.495 1.281h-2c0-.965.463-1.835.827-2.385a7.37 7.37 0 0 1 .705-.901l.054-.058.017-.017c.525-.572.958-.986 1.327-1.491.345-.473.552-.929.584-1.459C14.62 7.255 13.333 6 12.02 6 10.67 6 9.5 7.222 9.5 8.75h-2C7.5 6.278 9.412 4 12.019 4Z'
      />
    </svg>
  );
};

export default SvgQuestionMark;
